


























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { CourseProduct } from '@/model/product/courseProduct'

@Component
export default class LecturerMsgPC extends Vue {
  @Prop() private courseProduct!: CourseProduct
  private centerStyle = {
    display: 'flex',
    'justify-content': 'center'
  }
  get isCenter() {
    if (
      this.courseProduct.authors !== undefined &&
      this.courseProduct.authors.length <= 2
    ) {
      return true
    }
    return false
  }
}
